/**
 * ================================================================================
 * COMPONENTE: FAB (Floating Action Button)
 * PROPÓSITO: Botão flutuante com speed-dial para ações rápidas
 * ================================================================================
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, X, ArrowLeftRight, ArrowDownLeft, ArrowUpRight, Repeat } from 'lucide-react';

const actions = [
  { label: 'Despesa',        icon: ArrowUpRight,   color: '#EF4444', path: '/transactions/new?type=expense' },
  { label: 'Receita',        icon: ArrowDownLeft,  color: '#10B981', path: '/transactions/new?type=income' },
  { label: 'Transferência',  icon: ArrowLeftRight, color: '#8B5CF6', path: '/transactions/new?type=transfer' },
];

export default function FAB() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {/* Overlay */}
      {open && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 29, background: 'rgba(0,0,0,0.3)' }}
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Speed-dial actions */}
      {open && (
        <div className="fab-actions">
          {actions.map((action, i) => {
            const Icon = action.icon;
            return (
              <div key={i} className="fab-action-item" style={{ animationDelay: `${i * 50}ms` }}>
                <button
                  className="fab-action-btn"
                  style={{ background: action.color }}
                  onClick={() => { navigate(action.path); setOpen(false); }}
                  aria-label={`Criar ${action.label}`}
                >
                  <Icon size={20} />
                </button>
                <span className="fab-action-label">{action.label}</span>
              </div>
            );
          })}
        </div>
      )}

      {/* Main FAB */}
      <button
        className="fab"
        onClick={() => setOpen(!open)}
        style={{ transform: open ? 'rotate(45deg)' : 'rotate(0)' }}
        aria-label={open ? 'Fechar acoes rapidas' : 'Abrir acoes rapidas'}
        aria-expanded={open}
      >
        {open ? <X size={24} /> : <Plus size={24} />}
      </button>
    </>
  );
}
